{
    "nerd": {
        "position": {
            "x": 6,
            "y": 4,
            "z": 1
        },
        "key": "nerd"
    },
    "teacher": {
        "position": {
            "x": 5,
            "y": 3,
            "z": 1
        },
        "key": "teacher",
        "items": {}
    }
}